import React from 'react';
import { SEASON_MONTHS, pickSeasonMonth } from '@radevents/shared';

interface Props {
  from: number | null;
  until: number | null;
  onChange: (from: number | null, until: number | null) => void;
  /** Stil der beiden Auswahlfelder — jedes Formular bringt seinen eigenen mit. */
  selectClassName?: string;
  selectStyle?: React.CSSProperties;
  labelClassName?: string;
  labelStyle?: React.CSSProperties;
  idPrefix: string;
}

/**
 * Saison eines permanenten Events als Monatspaar (docs/bereiche/permanente-events.md): leer heißt
 * ganzjährig, über den Jahreswechsel („November bis März") geht auch. Wie eine Seite die andere
 * mitnimmt, regelt `pickSeasonMonth` (dieselbe Regel wie in der App).
 */
export default function SeasonSelect({ from, until, onChange, selectClassName, selectStyle, labelClassName, labelStyle, idPrefix }: Props) {
  const pick = (side: 'from' | 'until', raw: string) => {
    const next = pickSeasonMonth(side, raw ? Number(raw) : null, from, until);
    onChange(next.seasonFrom, next.seasonUntil);
  };
  const options = (
    <>
      <option value="">ganzjährig</option>
      {SEASON_MONTHS.map((name, i) => <option key={name} value={i + 1}>{name}</option>)}
    </>
  );
  return (
    <>
      <div>
        <label htmlFor={`${idPrefix}-season-from`} className={labelClassName} style={labelStyle}>Saison von</label>
        <select id={`${idPrefix}-season-from`} value={from ?? ''} onChange={e => pick('from', e.target.value)}
          className={selectClassName} style={selectStyle}>
          {options}
        </select>
      </div>
      <div>
        <label htmlFor={`${idPrefix}-season-until`} className={labelClassName} style={labelStyle}>bis</label>
        <select id={`${idPrefix}-season-until`} value={until ?? ''} onChange={e => pick('until', e.target.value)}
          className={selectClassName} style={selectStyle}>
          {options}
        </select>
      </div>
    </>
  );
}
